export interface CacheEntry<T> {
  data: T;
  version: string;
  timestamp: number;
}

export class WlCache {
  private static readonly PREFIX = 'wl:';

  static set<T>(key: string, data: T, version: string): void {
    const entry: CacheEntry<T> = {
      data,
      version,
      timestamp: Date.now(),
    };
    try {
      localStorage.setItem(
        `${WlCache.PREFIX}${key}`,
        JSON.stringify(entry)
      );
    } catch (e) {
      console.warn(`Cache write failed: ${key}`, e);
    }
  }

  static get<T>(key: string, expectedVersion: string): T | null {
    try {
      const raw = localStorage.getItem(`${WlCache.PREFIX}${key}`);
      if (!raw) return null;

      const entry: CacheEntry<T> = JSON.parse(raw);
      
      // Version mismatch = invalidate
      if (entry.version !== expectedVersion) {
        WlCache.remove(key);
        return null;
      }

      return entry.data;
    } catch (e) {
      console.warn(`Cache read failed: ${key}`, e);
      return null;
    }
  }

  static remove(key: string): void {
    localStorage.removeItem(`${WlCache.PREFIX}${key}`);
  }

  static clear(): void {
    Object.keys(localStorage)
      .filter(k => k.startsWith(WlCache.PREFIX))
      .forEach(k => localStorage.removeItem(k));
  }
}
